// Chás Tradicionais Citados no Guia — página 39 do PDF. Fiel ao material.

export const TEAS = [
  {
    id: "respiracao",
    foco: "Respiração e Metal",
    elemento: "metal",
    chas: ["hortelã", "gengibre", "tomilho"],
    orgaos: "Pulmão e Intestino Grosso",
    cuidado: "Evite exageros e observe sensibilidade individual.",
    sourcePages: [39],
  },
  {
    id: "digestao",
    foco: "Digestão e Terra",
    elemento: "terra",
    chas: ["gengibre", "erva-doce", "camomila"],
    orgaos: "Estômago e Baço-Pâncreas",
    cuidado: "Prefira morno e sem excesso de açúcar.",
    sourcePages: [39],
  },
  {
    id: "calma",
    foco: "Calma e Fogo",
    elemento: "fogo",
    chas: ["camomila", "melissa", "lavanda"],
    orgaos: "Coração e Pericárdio",
    cuidado: "Não use para substituir cuidado em crises intensas.",
    sourcePages: [39],
  },
  {
    id: "liquidos",
    foco: "Líquidos e Água",
    elemento: "agua",
    chas: ["cavalinha", "cabelo de milho", "hibisco"],
    orgaos: "Rins e Bexiga",
    cuidado: "Atenção em alterações urinárias, gestação ou uso de medicamentos.",
    sourcePages: [39],
  },
  {
    id: "movimento",
    foco: "Movimento e Madeira",
    elemento: "madeira",
    chas: ["boldo", "hortelã", "carqueja", "dente-de-leão"],
    orgaos: "Fígado e Vesícula Biliar",
    cuidado: "Use com moderação e busque orientação se houver dor forte ou icterícia.",
    sourcePages: [39],
  },
];

export const TEA_WARNING =
  "Os chás abaixo aparecem ao longo do guia como referências tradicionais. Eles não substituem avaliação profissional e devem ser usados com bom senso, especialmente em gestação, doenças, uso de remédios ou sintomas persistentes. Esta página é uma referência educativa. Não indica dose, tratamento ou substituição de cuidados profissionais.";

export const TEA_ANTES = [
  "Observe seu contexto.",
  "Evite misturas exageradas.",
  "Prefira preparo simples.",
  "Respeite restrições pessoais.",
  "Procure orientação quando necessário.",
];
